<template>
  <div class="devcomp">
    <el-row>
      <el-col :span="24">
        <div  style="text-align: center;">
          <el-form :inline="true" class="demo-form-inline" >

            <el-form-item label="  ">
              <el-button type="success" @click="limit = '1440'; onRefresh()" icon="el-icon-star-off">1天</el-button>
            </el-form-item>

            <el-form-item label="  ">
              <el-button type="success" @click="limit = '2880'; onRefresh()" icon="el-icon-star-off">2天</el-button>
            </el-form-item>

            <el-form-item label="  ">
              <el-button type="success" @click="limit = '4320'; onRefresh()" icon="el-icon-star-off">3天</el-button>
            </el-form-item>

            <el-form-item label="  ">
              <el-button type="success" @click="limit = '10080'; onRefresh()" icon="el-icon-star-off">7天</el-button>
            </el-form-item>

          </el-form>

        </div>

        <div class="Echarts" style="margin:15px">
          <div id="chartmain" style="width: 100%; height: 700px"></div>
        </div>

      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  data() {
    return {
      searchsn: "",//按SN查找
      reverseFlag: false,
      tbdata: {
        x: [],
        y1: [],
        y2: [],
        y3: [],
      },

      limit: "1440",

      excelTime: [],


      myChart: {},
      option: {},

    }
  },
  created() {
    this.info = this.$store.state.userInfo
  },
  mounted() {
    this.myChart = this.$echarts.init(document.getElementById('chartmain'))
    // this.updateEcharts()
    this.onRefresh()

  },
  beforeDestroy() {
  },
  methods: {


    // 主刷新
    async onRefresh() {
      let res = await this.$api.get_online_charts({
        limit: this.limit + "",
      })
      console.log("onRefresh", res)
      if (res.status == 1) {
        this.tbdata = res.tbdata
        this.updateEcharts()
      }
    },
    updateEcharts() {
      // 指定图表的配置项和数据
      this.option = {
        title: {
          text: "4G在线数量"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["服务器1", "服务器2", "服务器3"]
        },
        xAxis: {
          data: this.tbdata.x
        },
        yAxis: {
          scale: true,
          minInterval: 1
        },
        series: [
          {
            name: "服务器1",
            type: "line",
            data: this.tbdata.y1,
            lineStyle: { width: 2 },
            itemStyle: { color: "#5470C6" },
            symbol: "circle",
            symbolSize: 6
          },
          {
            name: "服务器2",
            type: "line",
            data: this.tbdata.y2,
            lineStyle: { width: 2 },
            itemStyle: { color: "#91CC75" },
            symbol: "circle",
            symbolSize: 6
          },
          {
            name: "服务器3",
            type: "line",
            data: this.tbdata.y3,
            lineStyle: { width: 2 },
            itemStyle: { color: "#FAC858" },
            symbol: "circle",
            symbolSize: 6
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(this.option)
    },


  },
}
</script>

<style scoped>
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}


.detail-card .el-button {
  margin: 8px;
  margin-bottom: 14px;
  font-size: 16px;
  width: 92%
}
</style>
